import {Group, Stack, Text, TextInput} from "@mantine/core";
import classes from "./SettingSelectField.module.css";

const defaultRenderValue = (value: string) => {
    return <TextInput className={classes.innerItem} value={value} disabled />;
};

export function NonEditableField({
    label,
    description,
    value,
    onRenderValue,
}: {
    label: string;
    description: string;
    value: string;
    onRenderValue?: (value: string) => React.ReactNode;
}) {
    return (
        <Group className={classes.outer}>
            <Stack gap="0" className={classes.innerItem}>
                <Text>{label}</Text>
                <Text c="dimmed" fz="xs">
                    {description}
                </Text>
            </Stack>
            {onRenderValue ? onRenderValue(value) : defaultRenderValue(value)}
        </Group>
    );
}
